import styled from 'styled-components'

export const ConversationTelemetryShellStyled = styled.div`
  border-top: 1px dashed ${(props) => props.theme.colors.form.field.border};
  margin-top: ${(props) => props.theme.space.small};
  font-size: ${(props) => props.theme.typography.pxToRem(12)};
  color: ${(props) => props.theme.colors.text.secondary};
`
